import { DestroyRef, inject } from '@angular/core';
import { EnhancedUiService } from './enhanced-ui.service';

export interface AttachEnhancedUiOptions {
  /**
   * Also adopt the value from the user's settings (the shared, cached read).
   * Only where the user is known: a signed-in shell, not a signed-out page,
   * which keeps the value stored in this browser.
   */
  syncFromUserSettings?: boolean;
}

/**
 * Lets the Enhanced UI effects show while the calling component exists:
 * attaches now and detaches when the component is destroyed. Call from an
 * injection context (a field initializer or the constructor).
 */
export function attachEnhancedUi(options: AttachEnhancedUiOptions = {}): EnhancedUiService {
  const enhancedUi = inject(EnhancedUiService);
  enhancedUi.attach();
  inject(DestroyRef).onDestroy(() => enhancedUi.detach());
  if (options.syncFromUserSettings) enhancedUi.syncFromUserSettings();
  return enhancedUi;
}
